export default __webpack_public_path__ + "static/article-the-hunt-for-a-reliable-car-what-matters-b08a8426be3ae83c958d4b8946f02c4c.jpg";